import script from "./RentersTenantsDetailedView.vue?vue&type=script&setup=true&lang=js"
export * from "./RentersTenantsDetailedView.vue?vue&type=script&setup=true&lang=js"

import "./RentersTenantsDetailedView.vue?vue&type=style&index=0&id=d6837bfe&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6837bfe"]])

export default __exports__